import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ApiHelper from "../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../Helpers/EnumHelper";
import DemographicInfoColumn from "../../../Admin/Candidate/Components/DemographicInfoColumn";
import CvUploadButton from "../../../Admin/Candidate/Components/CvUploadButton";
import IconSvg from "../../../SharedComponents/IconSvg";

const CompanyCard = ({ companyData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card className="default-card p-3">
      <Row className={"mb-3 justify-content-between"}>
        <Col xs={12} md={"auto"} className={"border-end"} style={{ borderColor: "#E7ECEF" }}>
          <Row className={"justify-content-center"}>
            <Col xs={"auto"}>
              <Image
                src={ApiHelper.cloudFrontURL + folderEnum.logo + companyData.companyLogoImageName}
                height="80"
                width="250"
              />
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={"auto"} className={"align-content-center"}>
          <Row className={"mx-0 justify-content-center"}>
            <Col xs={"auto"}>
              <Row className={"justify-content-center"}>
                <Col xs={"auto"} className={"px-0 align-content-center text-18 text-color-gray-light"}>
                  {t("companyName")}:
                </Col>
              </Row>
              <Row className={"justify-content-center"}>
                <Col xs={"auto"} className={"px-1 align-content-center text-20 text-color-gray-dark fw-semibold"}>
                  {companyData?.companyName}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col xs={12} md={"auto"} className={"border-start"} style={{ borderColor: "#E7ECEF" }}>
          <Row className={"justify-content-center h-100 mx-0"}>
            <Col xs={"auto"} className={"align-content-center"}>
              <CvUploadButton
                cvNavigateIsShown={true}
                candidateId={companyData.candidateId}
                cvFileName={companyData.cvFileName}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <div className={"position-relative"}>
        <div
          className="hover-bg-darken p-1 absolute-top-right corner"
          onClick={() => {
            navigate("/demographyForm", {
              state: { ...companyData, isDismissable: true, isComingFromMyProfile: true },
            });
          }}
        >
          <IconSvg icon="edit" />
        </div>
        <DemographicInfoColumn candidate={companyData} isCollapsible={true} isUser={true} />
      </div>
    </Card>
  );
};

export default CompanyCard;
